<template>
    <b-modal v-model="show" title="РЕГРЕССИЯ РЕФЕРЕНСЛАР">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Парент <span class="red">*</span></label>
                        <v-select v-model="data.parent" label="name"
                                  :options="parents"
                                  :filterable="false"
                                  @search="onParentSearch"
                                  @search:focus="onParentFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Код<span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст<span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru)<span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.nameRu")}}</div>
                    </div>
                    <div class="form-check">
                        <label class="form-check-label pl-0">
                            <input type="checkbox" class="form-check-input" v-model="data.active">
                            <span class="form-check-sign"></span>
                            Актив
                        </label>
                    </div>
                    <div class="form-group">
                        <label>Қўшимча динамик параметерлар</label>
                        <div class="table-responsive">
                            <div class="table-wrapper">
                              <table class="table table-striped" style="min-width: 450px;">
                                  <thead>
                                      <tr>
                                          <th width="20%">Код</th>
                                          <th width="30%">Текст</th>
                                          <th width="20%">Тип</th>
                                          <th width="100%">Қиймат</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                  <template v-if="data.data && data.data.fields">
                                      <tr v-for="(field, index) in data.data.fields" :key="index">
                                          <td>
                                              <input type="text" class="form-control" v-model="field.code"/>
                                          </td>
                                          <td>
                                              <input type="text" class="form-control" v-model="field.name"/>
                                          </td>
                                          <td>
                                              <select class="form-control" v-model="field.type">
                                                  <option value="TEXT">TEXT</option>
                                                  <option value="INTEGER">INTEGER</option>
                                                  <option value="DECIMAL">DECIMAL</option>
                                                  <option value="BOOLEAN">BOOLEAN</option>
                                              </select>
                                          </td>
                                          <td>
                                              <template v-if="field.type">
                                                  <template v-if="field.type === 'TEXT'">
                                                      <input type="text" class="form-control" v-model="field.value" />
                                                  </template>
                                                  <template v-else-if="field.type === 'INTEGER'">
                                                      <numeric-input v-model="field.value" />
                                                  </template>
                                                  <template v-else-if="field.type === 'DECIMAL'">
                                                      <numeric-input v-model="field.value" :precision="2" />
                                                  </template>
                                                  <template v-else-if="field.type === 'BOOLEAN'">
                                                      <div class="form-check">
                                                          <label class="form-check-label pl-0">
                                                              <input class="form-check-input" type="checkbox" v-model="field.value">
                                                              <span class="form-check-sign"></span>
                                                          </label>
                                                      </div>
                                                  </template>
                                              </template>
                                          </td>
                                      </tr>
                                  </template>
                                  <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right">
                                          <button class="all-btn add-btn icon-btn" @click="addValues">+</button>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_REFERENCE_REGRESSION_ADD')" @click="save">Сақлаш</button>
            <button class="all-btn delete-btn float-right mr-2" @click="show = false">Бекор қилиш</button>
        </div>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                data: this.initData(),
                parentFilter: initFilterModel(),
                parents: [],

            }
        },
        validations: {
            data: {
                code: {
                    required: required
                },
                name: {
                    required: required
                },
                nameRu: {
                    required: required
                }
            }
        },
        methods: {
            initData() {
                return {
                    code: '',
                    name: '',
                    nameRu: '',
                    active: true,
                    parentId: null,
                    parent: null,
                    data: {
                        fields: []
                    }
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                if (this.data.parent && this.data.parent.id && this.data.parent.id > 0) {
                    if (this.data.data.fields && this.data.data.fields.length > 0) {
                        this.data.data.fields = this.data.data.fields.filter((field) => {
                            return field.code && field.code.length > 0 && field.name && field.name.length > 0
                                && field.type && field.type.length > 0 && field.value;
                        });

                        this.data.data.values = {};
                        this.data.data.fields.forEach((field) => {
                            this.data.data.values[field.code] = field.value;
                        });
                    }
                }

                this.$http.post('/building/field/reference', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('buildFieldReferenceChanged', response)
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err)
                    })
            },
            prepareCustomData(data) {
                if (!data.data) {
                    data.data = {};
                }
                if (!data.data.fields) {
                    data.data.fields = [];
                }
            },
            addValues() {
                this.prepareCustomData(this.data);
                this.data.data.fields.push({
                    code: '',
                    name: '',
                    type: '',
                    value: null
                });
            },
            onParentSearch(searchTxt, loading) {
                loading(true);
                this.parents = [];
                this.parentFilter.search = searchTxt;
                this.$http.post('/building/field/reference/list', this.parentFilter)
                    .then(res => {
                        this.parents = res.data.data;
                        loading(false)
                    }, err => {
                        console.log(err)
                    })

            },
            onParentFocus() {
                this.parents = [];
                this.parentFilter.search = '';
                this.$http.post('/building/field/reference/list', this.parentFilter)
                    .then(res => {
                        this.parents = res.data.data;
                    }, err => {
                        console.log(err)
                    })
            }
        },
        created() {
            this.parentFilter.parentOnly = true;
            this.parentFilter.page.size = 1000;
            this.$eventBus.$on('showBuildingFieldReferenceEditModal', (data) => {
                if (data) {
                    this.prepareCustomData(data);
                    this.data = clone(data)
                } else {
                    this.data = this.initData();
                }
                this.show = true
            })
        }
    }
</script>

<style scoped>

</style>